// third party
import { combineReducers } from 'redux';

// project imports
import snackbarReducer from './slices/snackbar';
import reduxDataReducer from './slices/reduxData';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  reduxData: reduxDataReducer,
  snackbar: snackbarReducer
});

export default reducer;
